import { env } from "@/config/env"
import type { ProductPlan } from "./types"

/**
 * Single fallback plan, shown only when no funnel config and no `plan`/`plans`
 * URL params are present (e.g. opening the app directly without a cfg_ id).
 * In production the real plans come from the config or the URL params.
 *
 * Set VITE_DEFAULT_PLAN_ID to the provider plan id you want charged in that case.
 */
export const defaultPlan: ProductPlan = {
  id: "default",
  name: "Premium",
  description: "Full access",
  price: 29.99,
  currency: "USD",
  interval: "monthly",
  priceId: env.VITE_DEFAULT_PLAN_ID,
  features: ["Full access", "Cancel anytime"],
}

export function getDefaultPlan(): ProductPlan {
  return defaultPlan
}
